/**
 * detectCurrency — v146.43
 *
 * Runs entirely in the browser so we don't need any server-side geo IP
 * lookup. Uses the visitor's Intl timezone as a fast, reliable proxy:
 *   Asia/Kolkata / Asia/Calcutta → INR
 *   everything else              → USD
 *
 * The result is memoised for the lifetime of the tab so repeated calls
 * are free. The visitor can flip currency manually via localStorage
 * ("linkola:currency") — set from a pricing page toggle.
 */
let cached = null;

export function detectCurrency() {
  if (cached) return cached;
  try {
    const stored = typeof localStorage !== "undefined" ? localStorage.getItem("linkola:currency") : null;
    if (stored === "INR" || stored === "USD") {
      cached = stored;
      return cached;
    }
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const isIndia = tz === "Asia/Kolkata" || tz === "Asia/Calcutta";
    cached = isIndia ? "INR" : "USD";
  } catch {
    cached = "INR";
  }
  return cached;
}

export function setCurrencyOverride(currency) {
  if (currency !== "INR" && currency !== "USD") return;
  try { localStorage.setItem("linkola:currency", currency); } catch { /* noop */ }
  cached = currency;
}
